import type { SVGProps } from 'react';

export function IconFacebook(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M21 20.25H24.75L26.25 14.25H21V11.25C21 9.70593 21 8.25 24 8.25H26.25V3.21015C25.7614 3.14528 23.9145 3 21.9644 3C17.8926 3 15 5.48529 15 10.0496V14.25H10.5V20.25H15V33H21V20.25Z"
                fill="currentColor"
            />
        </svg>
    );
}
